import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
*{
    box-sizing:border-box;
    margin: 0;
    padding:0;
    font-size: small;
}
html, body, #root{
    height:100% auto;
}
*, button, input {
    border:0;
    font-family: 'Roboto', sans-serif ;
    outline:none;
}
button{
    cursor: pointer;
}
p {
    margin-bottom: 0 !important;
}
.nav-link.active {
    color: #eb6d03 !important;
    font-weight: bold;
}
.nav-link {
    color: #000000 !important;
    font-weight: bold;
}
`;
